import gql from 'graphql-tag';
import { CommentFragments } from './comment.fragments';

export class CommentQueries {
  static load = gql`
    query LoadComments($limit: Float, $offset: Float, $statuses: [CommentStatus!]!) {
      contextualComments(limit: $limit, offset: $offset, statuses: $statuses) {
        ...commentFragment
      }
    }
    ${CommentFragments.comment}
  `;
}
